import type { LangsType } from '@/_types/Shared/SiteDatas';
import { Link } from '@inertiajs/react';

export default function LangsMobile({ langs, itemClass }: { langs: LangsType; itemClass: any; }) {

	return (
		<div className='group relative flex gap-8'>
			<button className={itemClass.menuItems}>
				{langs.current}
			</button>
			{Object.entries(langs.others).map(([key, lang]) => (
				<button key={key} className={`opacity-50 ${itemClass.menuItems}`}>
					<Link className={itemClass.childMenuItems} href={lang.url}>{lang.slug}</Link>
				</button>
			))}
		</div>
	);
}